export default __webpack_public_path__ + "static/Blue_Gem-4463a0c8b7d10dc410aea726d2f21561.png";